import { Component, OnInit } from '@angular/core';

import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import {
  faFileImport,
  faCloudUploadAlt,
  faSyncAlt,
  faImage,
  faFileImage,
} from '@fortawesome/free-solid-svg-icons';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppSettings } from 'src/app/appSettings';
import { ProductService } from 'src/app/services/product.service';
import { SiteService } from 'src/app/services/site.service';
import { OperadorService } from '../services/operador.service';
import { AppFormat } from '../appFormat';
import { HelperService } from '../services/helper.service';
import { StoreService } from '../services/store.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
  host: { class: 'wrapper-welcome' },
})
export class WelcomeComponent implements OnInit {
  public loading: boolean = false;
  public loadingCEP: boolean = false;
  public changed: boolean = false;

  public modalOpen: boolean = false;

  public uploader!: FileUploader;
  public hasBaseDropZoneOver: boolean = false;

  public uploaderLogo!: FileUploader;
  public hasBaseDropLogoZoneOver: boolean = false;

  public faCloudUploadAlt = faCloudUploadAlt;
  public faSyncAlt = faSyncAlt;
  public faImage = faImage;
  public faFileImage = faFileImage;
  public imageLogo = '';

  public percent = 50;
  public steps_remaining = 2;

  public store_name = '';
  public error_name: boolean = false;

  public warning_complete: boolean = true;

  public store_address_obj = null;

  public store = null;

  public app_owner: boolean = false;
  private app_owner_price: number = 299;

  public subFrm: FormGroup;

  public razao_social: FormControl;
  public email: FormControl;
  public cnpj: FormControl;
  public cep: FormControl;
  public invalid_cep: boolean = false;

  public store_address: string = '';

  public plan: string = '';
  public plan_value: number = null;
  public total: number = null;

  private timeout_cep = null;

  public modalImportEx: boolean = false;

  constructor(
    private _operadorService: OperadorService,
    private _productService: ProductService,
    private _helperService: HelperService,
    private _siteService: SiteService,
    private _storeService: StoreService,
    private router: Router
  ) {
    var welcome_steps = localStorage.getItem('welcome_steps');
    if (welcome_steps) {
      switch (welcome_steps) {
        case '50':
          this.percent = 50;
          this.steps_remaining = 2;
          break;
        case '75':
          this.percent = 75;
          this.steps_remaining = 1;
          break;
        case '100':
          this.percent = 100;
          this.steps_remaining = 0;

          var welcome_steps_complete = localStorage.getItem(
            'welcome_steps_complete'
          );
          if (welcome_steps_complete) {
            this.warning_complete = false;
          }

          localStorage.setItem('welcome_steps_complete', 'complete');

          break;
      }
    }

    let op = this._operadorService.getOperador();

    this.store = op.estabelecimento;

    if (this.store['periodo_teste'] == null) {
      this.router.navigate(['/app/visao-geral']);
    } else {
      let test = this.store['periodo_teste'];
      if (test.over) {
        this.warning_complete = false;
        this.percent = 100;
        this.steps_remaining = 0;
      }
    }

    this.store_name = this.formatSubdominio(this.store['nome']);

    /**
     *
     * envio do logo do estabelecimento
     *
     */

    this.uploaderLogo = new FileUploader({
      url: AppSettings.API_ENDPOINT,
      allowedFileType: ['image'],
      allowedMimeType: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      maxFileSize: 1048576 * 2,
      filters: [
        {
          name: 'imageFilter',
          fn: function (item: FileLikeObject | undefined, options) {
            if (item === undefined) return false;
            var type =
              '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
            return '|jpg|png|jpeg|gif|webp|'.indexOf(type) !== -1;
          },
        },
      ],
    });

    this.uploaderLogo.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploaderLogo.queue.length > 1) {
        this.uploaderLogo.removeFromQueue(this.uploaderLogo.queue[0]);
      }

      this.imageLogo = '';
    };

    this.uploaderLogo.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          this.imageLogo = responsePath['imagem_cabecalho'];
        }
      }
    };

    this.uploaderLogo.onCompleteAll = () => {
      this.uploaderLogo.clearQueue();
      this.saveCompleteLogo();
    };

    this.uploaderLogo.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao processar a imagem, verifique se a imagem está correta! Se é um arquivo válido de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploaderLogo.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de imagem (png, jpg, webp, gif) com no máximo 2 MB de tamanho!',
        'error'
      );
    };

    /**
     *
     * envio do excel de produtos do estabelecimento
     *
     */

    this.uploader = new FileUploader({
      url: AppSettings.API_ENDPOINT,
      autoUpload: true,
      allowedFileType: ['xls'],
      maxFileSize: 1048576 * 2,
    });

    this.uploader.setOptions(this._productService.getUrlImportProducts());

    this.uploader.onAfterAddingFile = (f) => {
      f.withCredentials = false;

      if (this.uploader.queue.length > 1) {
        this.uploader.removeFromQueue(this.uploader.queue[0]);
      }

      this.changed = true;
    };

    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: number,
      headers: any
    ) => {
      console.log(response);
      if (status == 200) {
        var responsePath = JSON.parse(response);
        if (responsePath['success']) {
          // this.files.unshift(responsePath['file']);
        }
      }
    };

    this.uploader.onCompleteAll = () => {
      this.uploader.clearQueue();
      this.changed = false;
      this.saveCompleteFile();
    };

    this.uploader.onErrorItem = (
      item: FileItem,
      response: any,
      status: any,
      headers: any
    ) => {
      item.remove();

      Swal.fire(
        'Ops!',
        'Ocorreu um erro ao enviar a planilha, verifique se a planilha está correta! Se é um arquivo válido com no máximo 2 MB de tamanho',
        'error'
      );
    };

    this.uploader.onWhenAddingFileFailed = function (
      item: FileLikeObject,
      filter: any,
      options: any
    ) {
      Swal.fire(
        'Ops!',
        'O arquivo selecionado não é válido, verifique se é um arquivo de planilha com no máximo 2 MB de tamanho!',
        'error'
      );
    };
  }

  ngOnInit(): void {
    this.createFormControls();
    this.createForm();

    if (this.store) {
      this.razao_social.setValue(this.store['razao_social']);
      this.cnpj.setValue(this.store['cnpj']);
      this.email.setValue(this.store['email']);
      this.cep.setValue(this.store['CEP']);

      this.store_address = this.store['full_address'];
    }
  }

  createFormControls() {
    this.razao_social = new FormControl('', [Validators.required]);
    this.cnpj = new FormControl('', [Validators.required]);
    this.email = new FormControl('', [Validators.required]);
    this.cep = new FormControl('', [Validators.required]);
  }

  createForm() {
    this.subFrm = new FormGroup({
      razao_social: this.razao_social,
      email: this.email,
      cnpj: this.cnpj,
      cep: this.cep,
    });
  }

  formatSubdominio(str) {
    return AppFormat.gSlug(str).replace('-', '').toLowerCase();
  }

  onFormatSub() {
    this.error_name = false;
    this.store_name = this.formatSubdominio(this.store_name);
  }

  confirmSubdomain() {
    Swal.fire({
      title: 'Verificando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });

    this._siteService
      .storeSubdomain({ name: this.store_name })
      .subscribe((res) => {
        if (res['success']) {
          Swal.fire({
            title: 'Endereço virtual criado com sucesso!',
            icon: 'success',
            showCancelButton: false,
            allowOutsideClick: false,
            showConfirmButton: true,
          });
          this._operadorService.setUrlStore(
            'http://' + this.store_name + '.superhoje.com/'
          );
          this.nextStep();
        } else {
          this.error_name = true;
          Swal.fire(
            'Ops!',
            'Este nome já está em uso, por favor escolha outro!',
            'error'
          );
        }
      });
  }

  nextStep() {
    this.percent += 25;
    this.steps_remaining -= 1;

    localStorage.setItem('welcome_steps', this.percent.toString());

    if (this.percent == 100) {
      localStorage.setItem('welcome_steps_complete', 'complete');
    }
  }

  onOpenModalImportEx() {
    this.modalImportEx = true;
  }

  onCloseModalImportEx() {
    this.modalImportEx = false;
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverLogoBase(e: any): void {
    this.hasBaseDropLogoZoneOver = e;
  }

  openModal(p) {
    this.plan = p;
    switch (p) {
      case 'Mini':
        this.plan_value = 99;
        break;
      case 'Super':
        this.plan_value = 299;
        break;
    }
    this.sumPlan();
    this.modalOpen = true;
  }

  sumPlan() {
    this.total = this.plan_value;
    if (this.app_owner) {
      this.total += this.app_owner_price;
    }
  }

  closeModal() {
    this.modalOpen = false;
  }

  saveError() {
    Swal.fire('Ops!', 'Ocorreu um erro ao tentar enviar.', 'error');
  }

  saveCompleteFile() {
    Swal.fire({
      title: 'O arquivo foi enviado com sucesso!',
      text: 'é possível verificar o status da importação em configurações > importação de dados',
      icon: 'success',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: true,
    });

    this.nextStep();
  }

  saveCompleteLogo() {
    Swal.fire({
      title: 'A logomarca foi enviada com sucesso!',
      icon: 'success',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: true,
    });
    this.nextStep();
  }

  saving() {
    Swal.fire({
      title: 'Enviando...',
      icon: 'info',
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false,
    });
  }

  aboutERP() {
    // sobre erp ??
    this.nextStep();
  }

  confirmLogo() {
    if (this.uploaderLogo.queue.length > 0) {
      this.saving();

      this.uploaderLogo.setOptions(this._siteService.getUrlLogoOptions());

      this.uploaderLogo.uploadAll();
    }
  }

  onCEPChange() {
    // search address
    if (this.cep && this.cep.value && this.cep.value.length >= 8) {
      if (this.timeout_cep) clearTimeout(this.timeout_cep);
      this.timeout_cep = setTimeout(() => {
        this.findCEP();
      }, 300);
    }
  }

  findCEP() {
    this.loadingCEP = true;
    this.store_address = '';
    this._helperService.findCEP(this.cep.value).subscribe((res) => {
      if (res.success) {
        if (res.localidades.length > 0) {
          let localidade = res.localidades[0];
          this.store_address_obj = localidade;

          this.store_address = localidade['endereco_completo'];

          this.invalid_cep = false;
        }
      } else {
        Swal.fire(
          'Ops!',
          'Não foi possível encontrar as informações para o CEP informado',
          'error'
        );
        this.invalid_cep = true;
      }

      this.loadingCEP = false;
    });
  }

  saveComplete() {
    Swal.fire('Assinado!', 'Sua assinatura foi realizada!', 'success');
  }

  onSubmitSubcribe() {
    //
    if (this.subFrm.valid) {
      this.saving();

      let dados = {
        razao_social: this.razao_social.value,
        cnpj: this.cnpj.value,
        email: this.email.value,
        cep: this.cep.value,
        plan: this.plan,
        app: this.app_owner ? 'S' : 'N',
      };

      if (this.store_address_obj) {
        dados['address'] = this.store_address_obj;
      }

      this._storeService.subscription(dados).subscribe((res) => {
        if (res['success']) {
          //
          this._operadorService.profile().subscribe((res) => {
            this.saveComplete();

            this.router.navigate(['/app/visao-geral']);
          });
          //
        } else {
          this.saveError();
        }
      });
    }
  }
}
